export class AutoRecallModel {
    recall_sequence: number
    item_code: string
    recall_days: number
    recall_code: string
    ask_user: number
    recall_clinic: number
    private _header: string

    set header(value: string) {
        this._header = value;
    }
    get header(): string {
        let strTmp = '';
        strTmp += `.  ${this.item_code} -- ${this.recall_days}`;
        if (this.ask_user)
            strTmp += ` -- Y -- ${this.recall_code}`;
        else
            strTmp += ` -- N -- ${this.recall_code}`;
        return strTmp
    }

    constructor(
        recall_sequence: number,
        item_code: string,
        recall_days: number,
        recall_code: string,
        ask_user: number,
        recall_clinic: number
    ) {
        this.recall_sequence = recall_sequence
        this.item_code = item_code
        this.recall_days = recall_days
        this.recall_code = recall_code
        this.ask_user = ask_user
        this.recall_clinic = recall_clinic
    }
}